import React from 'react';
import Icon from '../../../components/AppIcon';

const StatusBadge = ({ status, type = 'visa', currentLanguage = 'fr' }) => {
  const visaStatusConfig = {
    approved: {
      icon: 'CheckCircle2',
      label: { fr: 'Approuvé', ar: 'موافق عليه' },
      className: 'bg-success/10 text-success border-success/20'
    },
    pending: {
      icon: 'Clock',
      label: { fr: 'En attente', ar: 'قيد الانتظار' },
      className: 'bg-warning/10 text-warning border-warning/20'
    },
    rejected: {
      icon: 'XCircle',
      label: { fr: 'Rejeté', ar: 'مرفوض' },
      className: 'bg-error/10 text-error border-error/20'
    },
    not_applied: {
      icon: 'AlertCircle',
      label: { fr: 'Non demandé', ar: 'لم يتم التقديم' },
      className: 'bg-muted text-muted-foreground border-border'
    }
  };

  const documentStatusConfig = {
    complete: {
      icon: 'CheckCircle2',
      label: { fr: 'Complets', ar: 'مكتملة' },
      className: 'bg-success/10 text-success border-success/20'
    },
    incomplete: {
      icon: 'AlertTriangle',
      label: { fr: 'Incomplets', ar: 'غير مكتملة' },
      className: 'bg-warning/10 text-warning border-warning/20'
    },
    missing: {
      icon: 'XCircle',
      label: { fr: 'Manquants', ar: 'مفقودة' },
      className: 'bg-error/10 text-error border-error/20'
    }
  };

  const paymentStatusConfig = {
    paid: {
      icon: 'CheckCircle2',
      label: { fr: 'Payé', ar: 'مدفوع' },
      className: 'bg-success/10 text-success border-success/20'
    },
    partial: {
      icon: 'Clock',
      label: { fr: 'Partiel', ar: 'جزئي' },
      className: 'bg-warning/10 text-warning border-warning/20'
    },
    pending: {
      icon: 'AlertCircle',
      label: { fr: 'En attente', ar: 'قيد الانتظار' },
      className: 'bg-muted text-muted-foreground border-border'
    },
    overdue: {
      icon: 'XCircle',
      label: { fr: 'En retard', ar: 'متأخر' },
      className: 'bg-error/10 text-error border-error/20'
    }
  };

  const configs = {
    visa: visaStatusConfig,
    document: documentStatusConfig,
    payment: paymentStatusConfig
  };

  const config = configs?.[type]?.[status] || {
    icon: 'HelpCircle',
    label: { fr: 'Inconnu', ar: 'غير معروف' },
    className: 'bg-muted text-muted-foreground border-border'
  };

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border caption font-medium ${config?.className}`}>
      <Icon name={config?.icon} size={14} />
      <span>{config?.label?.[currentLanguage]}</span>
    </span>
  );
};

export default StatusBadge;